import React, {FC, useEffect, useState} from "react";
import "../assets/styles/styles.scss";
import axios from "axios";
import {MenuInterface} from "../model/MenuInterface";
import {useTypedSelector} from "../reducers";

import {Link} from "react-router-dom";
import {getLink} from "../api/MenuApi";
import { handleError } from "../error/ErrorHandler";
import logo from "../assets/images/shine/header_logo_white.svg";

const Menu: FC = () => {
    const {site} = useTypedSelector(state => state.profile);
    const { loginUser } = useTypedSelector(state => state.auth);
    const [menuAll, setMenuAll] = useState([]);
    const [environment, setEnvironment] = useState("");

    const getMenuResult = async () => {
        try {
            const res = await axios.get(`/api/menu/all`);
            if (res.data) {
                if (loginUser?.usrAuth === 'A') setMenuAll(res.data)
                else if (loginUser?.usrAuth !== 'A') {
                    res.data.map((menu: MenuInterface) =>{
                        if (menu.menuNm == '이용안내') {
                            menu.subList = menu.subList.filter((subMenu: MenuInterface, idx: number) => subMenu.menuNm !== '컨텐츠 관리');
                        }
                    });
                    setMenuAll(res.data);
                }
            }
        } catch(err) {
            handleError(err);
        }
    };
    useEffect(() => {
        getMenuResult();
    }, [loginUser?.usrAuth]);

    useEffect(() => {
        if (navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('not-pc');   // 모바일(스마트폰+태블릿)일 때
        }
        // PC에서만 실행 될 스크립트  /*************** 테스트용 ***************/
        if (!navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('pc');
            // setEnvironment('not-pc');
        }
    }, [environment]);

    const makeEachSubmenu = (subMenu: MenuInterface) => {
        if(subMenu.menuNm === '데이터 신청'){
            subMenu.route = environment === 'not-pc' ? '#' : '/request';
        }
        const onClickDataRequest = () => {
            if (environment === 'not-pc' && subMenu.menuNm === '데이터 신청') {
                alert('PC 환경에서 이용 바랍니다.');
            }
        }

        return (
            <Link to={getLink(subMenu)} key={subMenu.menuId} onClick={onClickDataRequest}>
                <div className={'menu-secondary-item'}>
                    <span>{subMenu.menuNm}</span>
                </div>
            </Link>
        )
    };

    const getSubmenuList = (subList: MenuInterface[]) => {
        let result: JSX.Element[] = [];
        subList.forEach((subMenu) => {
            result.push(makeEachSubmenu(subMenu));
        });
        return result;
    }

    const menuList = menuAll.map((menu: MenuInterface) =>
        (<div className={`menu-primary-item ${site}`} key={menu.menuId}>
            <span>{menu.menuNm}</span>
            <div className={'menu-secondary-item-wrapper'}>
                {getSubmenuList(menu.subList)}
            </div>
        </div>)
    );

    return (
        <div className={'menu-wrapper wrapper'}>
            <div className={'menu-content content'}>
                {menuList}
            </div>
            <div className={'menu-responsive-wrapper'}>
                <Link to={'/'}>
                    <div className={'menu-responsive-logo'}
                         style={{ backgroundImage: `url(${logo})`, backgroundRepeat: 'no-repeat' }}>
                    </div>
                </Link>
                <div className={'menu-responsive-icon'}>
                    {/*<FontAwesomeIcon icon={faBars}/>*/}
                </div>
            </div>
        </div>
    )
}

export default Menu;
